import { render, staticRenderFns } from "./CrudTableHeader.vue?vue&type=template&id=7533d78a&scoped=true"
import script from "./CrudTableHeader.vue?vue&type=script&lang=js"
export * from "./CrudTableHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7533d78a",
  null
  
)

export default component.exports